import ga from 'react-ga';
import debug from 'debug';

import { getFlag } from 'config/flags';
import { GOOGLE_ANALYTICS_ID } from 'config/ga';
import { getLogglyTags, LOGGLY_KEY } from 'config/loggly';
import { SENTRY_DSN } from 'config/sentry';

import { formatArgs } from 'utils/logglyHelper';

const log = debug('startup:logging');
const isProd = getFlag('env') === 'prod';

/**
 * Sentry
 */
if (window.Raven) {
  window.Raven.config(SENTRY_DSN[getFlag('env')], {
    ignoreUrls: [/localhost/],
  });

  if (isProd) {
    log('Setting up Sentry');

    // In dev, we don't want errors to be caught for sourcemaps to kick in
    window.Raven.install();
  }
}

/**
 * Loggly
 */
if (isProd) {
  const loggly = window._LTracker || [];
  const logglyKey = LOGGLY_KEY;
  const sendConsoleErrors = true;
  const tag = getLogglyTags().join(',');

  log('Setting up Loggly | tags: %s', tag);

  loggly.push({ logglyKey, sendConsoleErrors, tag });

  // To avoid the color info being added
  // Note: Overriding debug.useColors doesn't work.
  debug.formatArgs = () => {};
  const oldLog = debug.log;
  debug.log = (...args) => {
    oldLog(...args);
    const result = formatArgs(...args);
    loggly.push(result);
  };
}

/**
 * Google Analytics
 */
log('Setting up Google Analytics');
ga.initialize(GOOGLE_ANALYTICS_ID[getFlag('env')], { debug: !isProd });

/**
 * Debug
 */
window.debug = debug;

if (!isProd) {
  window.debug.enable('*,-sockjs-client:*');
}



// WEBPACK FOOTER //
// ./src/startup/logging.js